
export const FIRST_SCREEN_STATIC = {
    "ro": {
        "web.personalized.plan": "Primește un plan de învățare personalizat în funcție de obiectivele tale",
        "web.quiz.3min": "Chestionar de 3 minute",
        "web.profile.age": "Vârsta dvs.",
        "web.unlock.english.potential": "Descoperă-ți potențialul în limba engleză",
        "screen.practice.guide.control.next": "Următorul"
    },
    "ru": {
        "web.personalized.plan": "Получите персональный план обучения, разработанный с учетом\n        ваших целей",
        "web.quiz.3min": "Тест на 3 минуты",
        "web.profile.age": "Ваш возраст",
        "web.unlock.english.potential": "Раскройте свой потенциал в английском языке",
        "screen.practice.guide.control.next": "Далее"
    },
    "it": {
        "web.personalized.plan": "Ottieni un piano di apprendimento personalizzato in base ai tuoi obiettivi",
        "web.quiz.3min": "Quiz di 3 minuti",
        "web.profile.age": "La Sua età",
        "web.unlock.english.potential": "Sblocca il tuo potenziale in inglese",
        "screen.practice.guide.control.next": "Avanti"
    },
    "cs": {
        "web.personalized.plan": "Získejte personalizovaný studijní plán přizpůsobený vašim\n        cílům",
        "web.quiz.3min": "Tříminutový kvíz",
        "web.profile.age": "Váš věk",
        "web.unlock.english.potential": "Odemkněte svůj potenciál v angličtině",
        "screen.practice.guide.control.next": "Další"
    },
    "pt-BR": {
        "web.personalized.plan": "Obtém um plano de aprendizagem personalizado adaptado aos teus objetivos",
        "web.quiz.3min": "Questionário de 3 minutos",
        "web.profile.age": "Sua idade",
        "web.unlock.english.potential": "Desbloqueia o teu potencial em inglês",
        "screen.practice.guide.control.next": "Próximo"
    },
    "in": {
        "web.personalized.plan": "Dapatkan rencana belajar pribadi yang disesuaikan dengan tujuanmu",
        "web.quiz.3min": "Kuis 3 menit",
        "web.profile.age": "Usia Anda",
        "web.unlock.english.potential": "Tingkatkan potensi Bahasa Inggrismu",
        "screen.practice.guide.control.next": "Berikutnya"
    },
    "ja": {
        "web.personalized.plan": "あなたの目標に合わせた学習プランを作成します",
        "web.quiz.3min": "3分クイズ",
        "web.profile.age": "ご年齢",
        "web.unlock.english.potential": "英語の可能性を引き出そう",
        "screen.practice.guide.control.next": "次のページ"
    },
    "el": {
        "web.personalized.plan": "Αποκτήστε ένα εξατομικευμένο πλάνο μάθησης προσαρμοσμένο στους στόχους σας",
        "web.quiz.3min": "Τρίλεπτο τεστ",
        "web.profile.age": "Η ηλικία σας",
        "web.unlock.english.potential": "Ξεκλειδώστε τις δυνατότητές σας στα αγγλικά",
        "screen.practice.guide.control.next": "Επόμενο"
    },
    "no": {
        "web.personalized.plan": "Få en personlig læreplan tilpasset dine mål",
        "web.quiz.3min": "3-minutters quiz",
        "web.profile.age": "Alderen din",
        "web.unlock.english.potential": "Lås opp ditt engelske potensial",
        "screen.practice.guide.control.next": "Neste"
    },
    "pl": {
        "web.personalized.plan": "Otrzymaj spersonalizowany plan nauki dopasowany do Twoich celów",
        "web.quiz.3min": "3-minutowy quiz",
        "web.profile.age": "Państwa wiek",
        "web.unlock.english.potential": "Odblokuj swój potencjał w języku angielskim",
        "screen.practice.guide.control.next": "Dalej"
    },
    "sv": {
        "web.personalized.plan": "Få en personlig studieplan anpassad efter dina mål",
        "web.quiz.3min": "3-minuters quiz",
        "web.profile.age": "Din ålder",
        "web.unlock.english.potential": "Lås upp din engelska potential",
        "screen.practice.guide.control.next": "Nästa"
    },
    "tr": {
        "web.personalized.plan": "Hedeflerine göre özelleştirilmiş bir öğrenme planı al",
        "web.quiz.3min": "3 dakikalık test",
        "web.profile.age": "Yaşınız",
        "web.unlock.english.potential": "İngilizce potansiyelini ortaya çıkar",
        "screen.practice.guide.control.next": "Sonraki"
    },
    "en": {
        "web.personalized.plan": "Get a personalized learning plan tailored to your goals",
        "web.quiz.3min": "3 minute quiz",
        "web.profile.age": "Your age",
        "web.unlock.english.potential": "Unlock your English potential",
        "screen.practice.guide.control.next": "Next"
    },
    "fi": {
        "web.personalized.plan": "Hanki henkilökohtainen oppimissuunnitelma tavoitteidesi mukaan",
        "web.quiz.3min": "3 minuutin testi",
        "web.profile.age": "Ikäsi",
        "web.unlock.english.potential": "Avaa englannin kielen potentiaalisi",
        "screen.practice.guide.control.next": "Seuraava"
    },
    "fr": {
        "web.personalized.plan": "Obtenez un plan d'apprentissage personnalisé adapté à vos objectifs",
        "web.quiz.3min": "Quiz de 3 minutes",
        "web.profile.age": "Votre âge",
        "web.unlock.english.potential": "Libérez votre potentiel en anglais",
        "screen.practice.guide.control.next": "Suivant"
    },
    "es": {
        "web.personalized.plan": "Obtén un plan de aprendizaje personalizado adaptado a su objetivos",
        "web.quiz.3min": "Cuestionario de 3 minutos",
        "web.profile.age": "Su edad",
        "web.unlock.english.potential": "Desbloquea su potencial en inglés",
        "screen.practice.guide.control.next": "Siguiente"
    },
    "nl": {
        "web.personalized.plan": "Ontvang een gepersonaliseerd leerplan afgestemd op jouw doelen",
        "web.quiz.3min": "3 minuten quiz",
        "web.profile.age": "Uw leeftijd",
        "web.unlock.english.potential": "Ontgrendel je Engels potentieel",
        "screen.practice.guide.control.next": "Volgende"
    },
    "bg": {
        "web.personalized.plan": "Вземете персонализиран учебен план, съобразен с вашите цели",
        "web.quiz.3min": "3-минутен тест",
        "web.profile.age": "Вашата възраст",
        "web.unlock.english.potential": "Отключете своя потенциал по английски",
        "screen.practice.guide.control.next": "Следваща"
    },
    "nb": {
        "web.personalized.plan": "Få en personlig læreplan tilpasset dine mål",
        "web.quiz.3min": "3-minutters quiz",
        "web.profile.age": "Alderen din",
        "web.unlock.english.potential": "Lås opp ditt engelske potensial",
        "screen.practice.guide.control.next": "Neste"
    },
    "hi": {
        "web.personalized.plan": "अपने लक्ष्यों के अनुसार तैयार किया गया व्यक्तिगत लर्निंग प्लान प्राप्त करें",
        "web.quiz.3min": "3 मिनट का क्विज़",
        "web.profile.age": "आपकी आयु",
        "web.unlock.english.potential": "अपनी अंग्रेज़ी की क्षमता को अनलॉक करें",
        "screen.practice.guide.control.next": "अगला"
    },
    "de": {
        "web.personalized.plan": "Erhalte einen personalisierten Lernplan, der auf deine Ziele zugeschnitten ist",
        "web.quiz.3min": "3-Minuten-Quiz",
        "web.profile.age": "Ihr Alter",
        "web.unlock.english.potential": "Entfalte dein Englischpotenzial",
        "screen.practice.guide.control.next": "Weiter"
    },
    "ko": {
        "web.personalized.plan": "목표에 맞춘 맞춤형 학습 계획을 받아보세요",
        "web.quiz.3min": "3분 퀴즈",
        "web.profile.age": "귀하의 나이",
        "web.unlock.english.potential": "영어 실력을 최대한 끌어올리세요",
        "screen.practice.guide.control.next": "다음"
    },
    "ar": {
        "web.personalized.plan": "احصل على خطة تعلم مخصصة لأهدافك",
        "web.quiz.3min": "اختبار لمدة 3 دقائق",
        "web.profile.age": "عمرك",
        "web.unlock.english.potential": "اكتشف إمكانياتك في اللغة الإنجليزية",
        "screen.practice.guide.control.next": "التالي"
    },
    "pt": {
        "web.personalized.plan": "Obtém um plano de aprendizagem personalizado adaptado aos teus objetivos",
        "web.quiz.3min": "Questionário de 3 minutos",
        "web.profile.age": "A sua idade",
        "web.unlock.english.potential": "Desbloqueia o teu potencial em inglês",
        "screen.practice.guide.control.next": "Próximo"
    },
    "zh": {
        "web.personalized.plan": "获取一个根据你的目标定制的个性化学习计划",
        "web.quiz.3min": "3分钟测验",
        "web.profile.age": "您的年龄",
        "web.unlock.english.potential": "解锁你的英语潜能",
        "screen.practice.guide.control.next": "下一页"
    },
    "uk": {
        "web.personalized.plan": "Отримай персоналізований план навчання відповідно до своїх цілей",
        "web.quiz.3min": "3-хвилинний тест",
        "web.profile.age": "Ваш вік",
        "web.unlock.english.potential": "Розкрийте свій потенціал в англійській мові",
        "screen.practice.guide.control.next": "Далі"
    }
}